/**
 * 根据接口 detail message 归类生成“用户友好摘要”。
 * - 归类只影响 UI 主文案（摘要）
 * - 技术细节仍由 ErrorModal 的 detailMessage 展示
 */

const CATEGORY_RULES = [
  {
    categoryKey: 'errorCategoryAiNetworkError',
    priority: 96,
    // AI 网络异常（示例：Network Error / Failed to fetch / net::ERR_*）
    matchers: [
      /^network error$/i,
      /\bnetwork error\b/i,
      /failed to fetch/i,
      /net::err_/i
    ]
  },
  {
    categoryKey: 'errorCategoryAiTimeout',
    priority: 95,
    // AI 请求超时（示例：timeout of 120000ms exceeded）
    matchers: [
      /timeout of\s*\d+\s*ms exceeded/i,
      /\brequest timeout\b/i,
      /\becconnaborted\b/i
    ]
  },
  {
    categoryKey: 'errorCategoryImageSizeInvalid',
    priority: 100,
    // 图片尺寸/宽高约束类（示例：expected the width to be at least 300px ... received a 250x600px）
    matchers: [
      /expected the width to be at least/i,
      /expected the height to be at least/i,
      /\bat least\s*\d+\s*px/i,
      /\breceived a\s*\d+\s*x\s*\d+\s*px\b/i,
      /Error while downloading image/i
    ]
  },
  {
    categoryKey: 'errorCategoryOutputEmptyOrSensitive',
    priority: 90,
    // 输出为空或疑似触发安全策略（示例：The output content is empty ... sensitive content）
    matchers: [
      /output content is empty/i,
      /output content/i,
      /sensitive content/i,
      /safety rules/i,
      /safety system/i,
      /rejected by the safety system/i,
      /your request was rejected/i,
      /blocked by safety/i,
      /please do not enter sensitive or harmful content/i,
      /harmful content/i,
      /Please modify the content/i,
      /Please modify/i,
      /安全策略/i,
      /安全系统/i,
      /被安全系统拒绝/i,
      /请求已被拒绝/i
    ]
  },
  {
    categoryKey: 'errorCategoryUpstreamBusy',
    priority: 80,
    // 上游负载已饱和/服务繁忙
    matchers: [
      /upstream/i,
      /saturated/i,
      /overloaded/i,
      /load.*saturated/i,
      /负载.*饱和/i,
      /上游负载/i,
      /分组上游负载/i
    ]
  }
]

const NO_TAIL_CATEGORY_KEYS = {
  errorCategoryAiNetworkError: true,
  errorCategoryAiTimeout: true
}

function normalizeText(s) {
  var str = s == null ? '' : String(s)
  // Remove request id tokens to make matching more stable.
  str = str.replace(/\(?(?:request id|Request id)\s*[:：]\s*[^\)\n]+(?:\))?/gi, '')
  // Collapse whitespaces/newlines.
  str = str.replace(/\s+/g, ' ')
  return str.trim()
}

export function getFriendlyErrorSummaryFromDetail(detailMessage, t, fallbackSummary) {
  var fb = fallbackSummary != null ? String(fallbackSummary) : ''
  if (!detailMessage) return fb
  if (!t || typeof t !== 'function') return fb

  var text = normalizeText(detailMessage)
  if (!text) return fb

  // Apply rules by descending priority.
  var rules = CATEGORY_RULES.slice().sort(function(a, b) { return (b.priority || 0) - (a.priority || 0) })

  for (var i = 0; i < rules.length; i++) {
    var rule = rules[i]
    var matched = false
    for (var j = 0; j < rule.matchers.length; j++) {
      var m = rule.matchers[j]
      if (m && m.test && m.test(text)) {
        matched = true
        break
      }
    }
    if (matched) {
      var prefix = t('common.' + rule.categoryKey)
      var tail = t('common.tryAgainOrContactSupportTail')
      if (NO_TAIL_CATEGORY_KEYS[rule.categoryKey]) {
        return String(prefix || fb)
      }
      return String(prefix || fb) + String(tail || '')
    }
  }

  return fb
}

